import cookie from "js-cookie";

//set in cookie
export const setCookie = (key, value) => {
  if (window !== "undefined") {
    cookie.set(key, value, {
      expires: 7,
    });
  }
};

//remove from cookie
export const removeCookie = (key) => {
  if (window !== "undefined") {
    cookie.remove(key);
  }
};

//get from cookie (stored token)
export const getCookie = (key) => {
  if (window !== "undefined") {
    return cookie.get(key);
  }
};

//set in localstorage
export const setLocalStorage = (key, value) => {
  if (window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

// remove from localstorage
export const removeLocalStorage = (key) => {
  if (window !== "undefined") {
    localStorage.removeItem(key);
  }
};

//authenticate user by passing data to cooke and localstorage and sign in
//response after signin , next is callback function
export const authenticate = (response, next) => {
  setCookie("token", response.data.token);
  setLocalStorage("user", response.data.user);
  next();
};

//access userinfo from llocalstorage
export const isAuth = () => {
  if (window !== "undefined") {
    const cookieChecked = getCookie("refreshToken");
    if (cookieChecked) {
      return true;
    } else {
      return false;
    }
  }
};

export const signout = (next) => {
  removeCookie("token");
  removeLocalStorage("user");
  next();
};

export const updateUser = (response, next) => {
  if (window !== "undefined") {
    let auth = JSON.parse(localStorage.getItem("user"));
    auth = response.data;
    localStorage.setItem("user", JSON.stringify(auth));
    next();
  }
};

export const selectMultipleStaticData = (selectedItem, array) => {
  return array.map((item) => {
    if (item.value === selectedItem.value) {
      item.isSelected = !item.isSelected;
      return item;
    }
    return item;
  });
};

export const getArtistTypeNameFromValue = (value) => {
  switch (value) {
    case "makeupArtist":
      return "Makeup Artist";
    case "hairStylist":
      return "Hair Stylist";
    case "mehendiArtist":
      return "Mehendi Artist";
    default:
      return "N/A";
  }
};

export const capitalizeWord = (value) => {
  let capitalizedValue = value?.charAt(0).toUpperCase() + value?.slice(1);
  return capitalizedValue;
};

export const formatDate = (date) => {
  let tempDate, formattedDate;
  tempDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toJSON();
  return (formattedDate = tempDate.slice(0, 10).replace(/-/g, "/"));
};
